var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-wrapper"},[_c('Bar',{staticClass:"custom-class",style:({ minWidth: _vm.computedMinWidth }),attrs:{"chart-options":_vm.chartOptions,"chart-data":_vm.chartData,"chart-id":_vm.chartId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }